export default __webpack_public_path__ + "static/media/e6.86ef04af.jpeg";